import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";


export function miladiToShamsi(dateString) {
  if (!dateString) return "";
  try {
    const gregDate = new DateObject({ date: dateString, calendar: gregorian });
    const persianDate = gregDate.convert(persian, persian_fa);
    return persianDate.format("YYYY/MM/DD");
  } catch (err) {
    console.error("Error converting date:", err);
    return "";
  }
}
